import { render, staticRenderFns } from "./expExamineRecord.vue?vue&type=template&id=6bee33d2&scoped=true&"
import script from "./expExamineRecord.vue?vue&type=script&lang=js&"
export * from "./expExamineRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bee33d2",
  null
  
)

export default component.exports